import React, { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../header';
import Partners from '../partners';
import Footer from '../footer';
import Sidebar from '../guest-sidebar';
import css from './index.module.css';

interface Props {
  children: ReactNode;
  showFoter?: boolean;
}

export default function GuestLayout({ showFoter = false, children }: Props) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const footer = showFoter ? (
    <div className={css['always-down-of-page']}>
      <Partners />
      <Footer />
    </div>
  ) : (
    ''
  );

  return (
    <div className={`external-theme ${css['external']}`}>
      <Header />
      {children}

      {footer}

      <Sidebar />
    </div>
  );
}
